<template>


    <div v-if="!registered" class="overflow-container">
        <form action="" id="register-form" @submit.prevent="submitRegistration" novalidate>

            <div class="form-intro" v-html="getIntro"></div>

            <input type="hidden"
                   id="recaptcha_token"
                   name="recaptcha_token"
                   v-model="registrationFormData.recaptcha_token"/>


            <div class="input-group"
                 :class="formErrors.username ? 'has-errors' : ''">
                <label for="register-username">{{
                        'jeunes' === audienceMode ? copydeck.registrationUsernameField.fr : copydeck.registrationUsernameFieldProfs.fr
                    }}</label>
                <input name="register-username"
                       id="register-username"
                       type="text"
                       autocomplete="username"
                       v-model="registrationFormData.username"
                       @keydown="clearSingleFieldErrors('username')"
                       required>
                <form-error
                    v-if="formErrors.username"
                    :error="formErrors.username"
                ></form-error>

            </div>

            <div class="input-group"
                 :class="formErrors.email ? 'has-errors' : ''">
                <label for="register-email">{{
                        'jeunes' === audienceMode ? copydeck.registrationEmailField.fr : copydeck.registrationEmailFieldProfs.fr
                    }}</label>
                <input name="register-email"
                       id="register-email"
                       type="email"
                       autocomplete="email"
                       v-model="registrationFormData.email"
                       @keydown="clearSingleFieldErrors('email')"
                       required>

                <form-error
                    v-if="formErrors.email"
                    :error="formErrors.email"
                ></form-error>

            </div>

            <div class="input-group"
                 :class="formErrors.password ? 'has-errors' : ''">
                <label for="register-password">{{
                        'jeunes' === audienceMode ? copydeck.registrationPasswordField.fr : copydeck.registrationPasswordFieldProfs.fr
                    }}</label>
                <input name="register-password"
                       id="register-password"
                       type="password"
                       autocomplete="password"
                       v-model="registrationFormData.password"
                       @keydown="clearSingleFieldErrors('password')"
                       required>
                <form-error
                    v-if="formErrors.password"
                    :error="formErrors.password"
                ></form-error>

            </div>

            <div class="input-group"
                 :class="formErrors.password_confirmation ? 'has-errors' : ''">
                <label for="register-password-confirm">{{
                        'jeunes' === audienceMode ? copydeck.registrationPasswordConfirmationField.fr : copydeck.registrationPasswordConfirmationFieldProfs.fr
                    }}</label>
                <input name="register-password-confirm"
                       id="register-password-confirm"
                       type="password"
                       autocomplete="password"
                       v-model="registrationFormData.password_confirmation"
                       @keydown="clearSingleFieldErrors('password_confirmation')"
                       required>
                <form-error
                    v-if="formErrors.password_confirmation"
                    :error="formErrors.password_confirmation"
                ></form-error>

            </div>


            <div class="input-group has-checkbox"
                 :class="formErrors.consent ? 'has-errors' : ''" v-if=" 'profs' !== audienceMode">

                <input name="register-consent"
                       id="register-consent"
                       type="checkbox"
                       autocomplete="off"
                       v-model="registrationFormData.consent"
                       @change="clearSingleFieldErrors('consent')"
                       required>
                <label for="register-consent">{{ copydeck.consentField.fr }}</label>

                <form-error
                    v-if="formErrors.consent"
                    :error="formErrors.consent"
                ></form-error>
            </div>

            <div class="parents-message" v-if=" 'jeunes' === audienceMode && copydeck.messageParents.fr !== '' "
                 v-html=" copydeck.messageParents.fr "></div>

            <div class="centered submit-container">
                <button type="submit" class="button btn-submit btn-submit-registration" ref="btnRegisterSubmit">
                    <span class="ajax-loader white centered"></span> <span>{{ copydeck?.btnRegister?.fr }}</span>
                </button>
            </div>
        </form>

        <button type="button" class="text-link link-login link-mode-toggle"
                @click="changeMode('login')">{{
                'jeunes' === audienceMode ? copydeck?.btnAlreadyRegisteredToggle?.fr : copydeck?.btnAlreadyRegisteredToggleProfs?.fr
            }}
        </button>
    </div>

    <div v-if="registered" class=" success">
        <div class="as-logo-container"><img :src="logoRougeNoTextSrc" alt="Logo des As de l'info"></div>
        <h3 class="title" v-html="helloUserSuccess"></h3>
        <div class="content"
             v-html=" store.state.audienceMode === 'jeunes' ? ( copydeck?.registerSuccess?.fr ?? 'Succès!' )  : ( copydeck?.registerSuccessProfs?.fr ?? 'Succès! (profs)' ) "></div>
    </div>

</template>

<script>
export default {
    name : "Register",
}
</script>

<script setup>
// Vue
import { ref, reactive, computed } from 'vue';
import { useStore }                from 'vuex';
import axios                       from 'axios';


// store
let store    = useStore();
let copydeck = computed( () => store.state.copydeck );

const logoRougeNoTextSrc = new URL( '../../../../images/logo-rouge-no-text.svg', import.meta.url ).href;

// composables
import { changeMode, clearSingleFieldErrors } from '../composables';


// components
import FormError from './FormError.vue';


let audienceMode = computed( () => store.getters.audienceMode );

const registrationFormData = reactive( {
    username              : '',
    password              : '',
    password_confirmation : '',
    email                 : '',
    consent               : false,
    recaptcha_token       : '',
    audience              : audienceMode,
} );

let formErrors        = computed( () => store.state.formErrors );
let btnRegisterSubmit = ref( false );

let registered = computed( () => store.getters.isRegistered );


let getIntro = computed( () =>
{

    const introText = store.state.audienceMode === 'jeunes' ? (copydeck?.value?.registrationIntro?.fr ?? 'intro jeunes') : (copydeck?.value?.registrationIntroProfs?.fr ?? 'intro profs')


    return introText.replace( '[AS]', '<div class="as-logo-container"><img src="' + logoRougeNoTextSrc + '" alt="Logo des As de l\'info"></div>' ) ?? '';
} );

let helloUserSuccess = computed( () =>
{
    const textWithPlaceholder = store.state.audienceMode === 'jeunes' ? (copydeck?.value?.registerSuccessHeading?.fr ?? 'Succès!') : (copydeck?.value?.registerSuccessHeadingProfs?.fr ?? 'Succès!');

    return textWithPlaceholder.replace( '[USERNAME]', registrationFormData.username );

} )

async function submitRegistration ()
{

    btnRegisterSubmit.value.disabled = true;
    btnRegisterSubmit.value.classList.add( 'ajaxing' );


    try
    {
        const response = await axios.post( '/register', registrationFormData );

        if ( response?.data?.success ?? false )
        {
            store.commit( 'setRegistered' );

            // setTimeout( () =>
            // {
            //     window.location.reload();
            // }, 2000 );
        }
    }
    catch (error)
    {
        console.error( error, error.response, error.response.data, error?.response?.data?.errors ?? false );

        if ( error?.response?.data?.errors ?? false )
        {
            store.commit( 'addErrors', error?.response?.data?.errors );
        }
    }


    btnRegisterSubmit.value.disabled = false;
    btnRegisterSubmit.value.classList.remove( 'ajaxing' );
}


function reloadPage ()
{
    window.location.reload();
}

</script>

<style scoped>

</style>
